import React from "react";

export default function DashboardTotalOrderIcon()
{
      return (
            <svg
                  width={32}
                  height={32}
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
            >
                  <path
                        d="M26.6667 2.66667H5.33332C3.99999 2.66667 2.66666 3.86667 2.66666 5.33334V9.34667C2.66666 10.3067 3.23999 11.1333 3.99999 11.6V26.6667C3.99999 28.1333 5.46666 29.3333 6.66666 29.3333H25.3333C26.5333 29.3333 28 28.1333 28 26.6667V11.6C28.76 11.1333 29.3333 10.3067 29.3333 9.34667V5.33334C29.3333 3.86667 28 2.66667 26.6667 2.66667ZM18.6667 18.6667H13.3333C12.6 18.6667 12 18.0667 12 17.3333C12 16.6 12.6 16 13.3333 16H18.6667C19.4 16 20 16.6 20 17.3333C20 18.0667 19.4 18.6667 18.6667 18.6667ZM26.6667 9.33334H5.33332V5.33334H26.6667V9.33334Z"
                        fill="#4CC2FF"
                  />
            </svg>

      );
}
